var map = {
	"./1.png": "hADo",
	"./2.png": "CtMo",
	"./3.png": "POh1",
	"./4.png": "xU8L",
	"./5.png": "podQ",
	"./6.png": "EWpu",
	"./7.png": "ZUQc",
	"./audio-btn.png": "IOIH",
	"./cha/1.png": "3xGH",
	"./cha/2.png": "cczn",
	"./cha/3.png": "93dC",
	"./cha/4.png": "A1e1",
	"./cha/5.png": "p6BB",
	"./cha/6.png": "eYkZ",
	"./cha/7.png": "7Nqd",
	"./cha1-bg.png": "PhPp",
	"./cha2-bg.png": "yrCa",
	"./cha3-bg.png": "hPV7",
	"./cha4-bg.png": "FQ2W",
	"./cha5-bg.png": "YonC",
	"./cha6-bg.png": "cF73",
	"./cha7-bg.png": "OFAO",
	"./cn/name1.png": "FdJD",
	"./cn/name2.png": "ZmXC",
	"./cn/name3.png": "7RrE",
	"./cn/name4.png": "L82T",
	"./cn/name5.png": "1ykC",
	"./cn/name6.png": "d8Fw",
	"./cn/name7.png": "NfKF",
	"./en/name1.png": "BQBz",
	"./en/name2.png": "tX3l",
	"./en/name3.png": "xp3k",
	"./en/name4.png": "JoFo",
	"./en/name5.png": "jfYO",
	"./en/name6.png": "cYpM",
	"./en/name7.png": "xr5D",
	"./j-d.png": "Z22z",
	"./j-u.png": "Gg0S",
	"./th/name1.png": "xAXu",
	"./th/name2.png": "zDIW",
	"./th/name3.png": "QR8R",
	"./th/name4.png": "FWB1",
	"./th/name5.png": "pkPz",
	"./th/name6.png": "xkKY",
	"./th/name7.png": "lZ8x",
	"./tx1-b.png": "Dz8s",
	"./tx2-b.png": "1alT",
	"./tx3-b.png": "ojQ/",
	"./tx4-b.png": "TNr/",
	"./tx5-b.png": "jC5J",
	"./tx6-b.png": "YGTo",
	"./tx7-b.png": "qf+g",
	"./vol.png": "MoT2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uR98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/.*\.png$
// module id = uR98
// module chunks = 1